export default __webpack_public_path__ + "a9c7a30256e53f336ee72cb476c2ee25.png";